export class Banner {
    public idGeral?: string;
	public cdFilial: number;
	public cdUsuario: number;
	public dataFim: string;
	public dataFimDate:Date;
	public dataInicio: string;
	public dataInicioDate: Date;
	public cdAcesso?: string;
	public ordem: number;
	public img: string;
	public nomeImg: string;
    public flTelaLogin: boolean;
	public limparCampo: boolean;
	
	constructor(init?: Partial<Banner>) {
        Object.assign(this, init);
    }
}